import { Box, Dialog, DialogContent } from '@mui/material';
import { ReactNode } from 'react';
// 공지사항 이미지 import (src/assets/images에서 가져옴)
import noticeImage from '@/assets/images/20251124_Notice_AF.png';

type NoticeDialogProps = {
  open: boolean;
  imageSrc?: string;
  alt?: string;
  children?: ReactNode;
};

export default function NoticeDialog({ open, imageSrc = noticeImage, alt = '공지사항', children }: NoticeDialogProps) {
  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: '90%',
          maxHeight: '90vh',
          width: 'auto',
          height: 'auto',
          overflow: 'hidden',
        },
      }}
      // 클릭해도 닫히지 않도록 설정
      onClose={() => {}}
      disableEscapeKeyDown
    >
      <DialogContent
        sx={{
          p: 0,
          overflow: 'hidden',
          '&.MuiDialogContent-root': {
            padding: 0,
            overflow: 'hidden',
          },
        }}
      >
        {children ? (
          children
        ) : (
          <Box
            component="img"
            src={imageSrc}
            alt={alt}
            sx={{
              width: '100%',
              height: '100%',
              maxWidth: '90vw',
              maxHeight: '90vh',
              display: 'block',
              objectFit: 'contain',
              cursor: 'default', // 클릭해도 반응 없음
            }}
            onClick={(e) => {
              // 클릭해도 닫히지 않도록 이벤트 전파 방지
              e.stopPropagation();
            }}
            onError={(e) => {
              // 이미지 로드 실패 시 기본 이미지 또는 placeholder 표시
              console.warn(
                '공지사항 이미지를 불러올 수 없습니다. /public/assets/images/notice.png 경로에 이미지를 추가하세요.',
              );
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
